import { render, staticRenderFns } from "./FormInputStandardUserSendMessagesFunction.vue?vue&type=template&id=2c65c070&scoped=true&lang=pug"
import script from "./FormInputStandardUserSendMessagesFunction.vue?vue&type=script&lang=ts"
export * from "./FormInputStandardUserSendMessagesFunction.vue?vue&type=script&lang=ts"
import style0 from "./FormInputStandardUserSendMessagesFunction.vue?vue&type=style&index=0&id=2c65c070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65c070",
  null
  
)

export default component.exports